import React from 'react';
import Skeleton from 'react-loading-skeleton';

const FocusMultiformModalSkeleton = (): JSX.Element => {
    return (
        <section className="nettbank-transactions">
            <div className="focus-monitor nettbank-transactions__wrapper skeleton">
                <div className="nettbank-transactions__container is-themed">
                    <div className="sgw-tabs payment-and-transfer__tab-wrapper">
                        <div className="sgw-tabs__button-wrapper">
                            <div className="sgw-tabs__buttons">
                                <Skeleton width={200} height={40} borderRadius={20} />
                            </div>
                        </div>
                    </div>
                    <div className="sgw-tab is-selected">
                        <div className="transaction-form">
                            <div className="transaction-form__from-account-selector">
                                <Skeleton height={86} borderRadius={6} />
                            </div>
                            <div className="transaction-form__to-account-selector">
                                <Skeleton height={86} borderRadius={6} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FocusMultiformModalSkeleton;
